import cn from 'classnames';

const getZIndex = (length: number, index: number, currentIndex: number): number => {
  if (index === currentIndex) return length;
  if (index < currentIndex) return index;
  return length - index;
};

interface ITabListItemProps {
  isCurrent?: boolean;
  length: number;
  index: number;
  currentIndex: number;
  disabled?: boolean;
}

const TabListItem: React.FC<React.PropsWithChildren<ITabListItemProps>> = ({
  children,
  isCurrent,
  length,
  index,
  currentIndex,
  disabled
}) => (
  <li
    className={cn({ 'tab-list__item--is-active': isCurrent }, { disabled: disabled })}
    style={{
      zIndex: getZIndex(length, index, currentIndex)
    }}
  >
    {children}
  </li>
);

TabListItem.displayName = 'TabListItem';

export default TabListItem;
